<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition', 'pa-connection-message-badge-character-list-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .15}"
   :isFreez="isFreezModal"
   :couldOverlaySwipeClose="false"
   contentTransitionName="trans-content"

   @closeOverlayModal="handleCloseOverlay"
   @afterEnterContent="handleEnterContent"
   @afteredAfterEnterContent="handleAfterEnterContent"
  >
    <div class="pa-wide-modal-box-wrapper pa-pod-message-badge-character-list-modal-view">
      <div class="pa-wide-modal-box" ref="wideModalBox">
        <div class="pa-header" ref="paHeader">
          <div class="pa-title">
            「{{badgeItem.name}}」の付与者一覧
          </div>
          <div class="pa-description">
            <p>
              この投稿に「{{badgeItem.name}}」を付与した異界渡航者一覧です。
            </p>
          </div>
        </div>

        <div class="pa-content" ref="paContent">
          <transition name="pa-simple-fade">
            <ul class="character-list" v-if="isEnterdModal">
              <li v-for="item in badgeRelationList" :key="item.id">
                <PACharacterBanner :character="item.character" />
              </li>
            </ul>
          </transition>
        </div>
        
        <div class="pa-cancel-wrapper" ref="paCancel">
          <div class="pa-cancel">
            <button
            class="button pa-cancel-button"
            :class="cancelButtonClass"
            :disabled="isDisabledCancelButton"
            @click.prevent="handleCloseModal"
            >閉じる</button>
          </div>
        </div>
      </div>
      
      <transition name="pa-simple-fade" @beforeEnter="handleBeforeEnterLoading">
        <div class="pa-loading-set" v-if="isLoading">
          <div class="pa-loading-field" ref="loadingContent">
            <PuffLoadingImage stroke="#957E63" />
          </div>
          <div class="pa-loading-overlay" ref="loadingOverlay"></div>
        </div>

      </transition>

    </div>
  </PaOverlayModal>
</template>

<script>
import {GetPodMessageBadgeCharacterList} from '@/graphql/queries/ConnectionPod.graphql'

import PaOverlayModal     from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PACharacterBanner  from '@/components/Parts/PACharacterBanner/PACharacterBanner.vue'
import PuffLoadingImage from '@/components/Pages/Connections/ConnectionApp/Images/puff.svg?inlineN'

export default {
  components : {
    PaOverlayModal,
    PACharacterBanner,

    PuffLoadingImage
  },

  data(){
    return {
      isDisabledCancelButton    : false,
      cancelButtonClass         : [],

      isOpenModal   : false,
      isFreezModal  : false,

      podMessageId  : null,
      badgeId       : null,

      isEnterdModal : false,

      badgeRelationList : [],
      badgeItem         : {
        name  : ''
      }
    };
  },

  computed : {
    urlQuery(){
      return this.$route.query;
    },

    isLoading(){
      return this.$apollo.queries.podMessageBadgeCharacterList.loading;
    },

    isVisiblePageContent(){
      return this.$store.state.layouts.isVisiblePageContent;
    }
  },

  apollo: {
    podMessageBadgeCharacterList: {
      query: GetPodMessageBadgeCharacterList,

      variables(){
        return {
          podMessageId  : this.podMessageId,
          badgeItemId   : this.badgeId
        };
      },

      skip(){
        if( this.isEnterdModal === true && this.podMessageId !== null && this.isVisiblePageContent === true ){
          return false;
        }else{
          return true;
        }
      }
    }
  },

  watch : {
    urlQuery : {
      handler(data){
        if(typeof data !== 'object') return;

        if(
          (typeof data.pod_message_badge_character_list_id === 'undefined') && 
          (typeof data.pod_message_badge_character_list_badge_id === 'undefined')
        ){
          this.podMessageId = null;
          this.badgeId      = null;
        }else{
          this.podMessageId = data.pod_message_badge_character_list_id;
          this.badgeId      = data.pod_message_badge_character_list_badge_id;
        }

        this.isEnterdModal = false;
      },
      immediate: true,
      deep: true
    },

    podMessageId : {
      handler(value){
        if(typeof value === 'undefined') return;
        if(value === null) return;

        if(this.isOpenModal === false){
          // nextTickだと動かないので
          setTimeout(() => {
            this.isOpenModal = true;
          }, 250);
        }
      },
      immediate: true
    },

    podMessageBadgeCharacterList : {
      handler(data){
        this.badgeRelationList = data.relatedList;
        this.badgeItem         = data.item;
      }
    }
  },

  methods : {
    handleCloseModal(){
      this.isOpenModal = false;
    },

    handleCloseOverlay(){
      this.isOpenModal = false;

      const newUrlQuery = Object.assign({}, this.$route.query);

      if(newUrlQuery['y'] === 0){
        delete newUrlQuery.y;
      }

      delete newUrlQuery.pod_message_badge_character_list_id;
      delete newUrlQuery.pod_message_badge_character_list_badge_id;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    setModalContentHeight(){
      const maxTime   = 50;
      let timeCounter = 0;

      const intervalTimer = setInterval(() => {
        const actualBoxHeight = this.$refs.wideModalBox.offsetHeight;

        const headerHeight  = this.$refs.paHeader.offsetHeight;
        const cancelHeight  = this.$refs.paCancel.offsetHeight;

        timeCounter++;

        if(timeCounter > maxTime){
          clearInterval(intervalTimer);
        }

        if(actualBoxHeight === 0) return;

        const contentHeight = actualBoxHeight - (headerHeight + cancelHeight);

        this.$refs.paContent.style.height = contentHeight+'px';

        clearInterval(intervalTimer);
      }, 100);
    },

    handleEnterContent(){
      this.setModalContentHeight();
    },

    handleBeforeEnterLoading(){
      const boxHeight = this.$refs.wideModalBox.offsetHeight;

      this.$refs.loadingContent.style.height = boxHeight + 'px';
      this.$refs.loadingOverlay.style.height = boxHeight + 'px';
    },

    handleAfterEnterContent(){
      this.$nextTick(() => {
        this.isEnterdModal = true;
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-pod-message-badge-character-list-modal-view{
  position: relative;

  .pa-wide-modal-box{
    overflow: hidden;
    
    .pa-header{
      box-sizing:border-box;
    }

    .pa-content{
      padding-top:1rem;
      overflow-y: scroll;

      .character-list{
        li{
          width:95%;
          margin:0 auto 1rem;

          &:last-child{
            margin-bottom: 0;
          }
        }
      }
    }

    .pa-cancel-wrapper{
      box-sizing:border-box;
      padding-top:.5rem;
      padding-bottom:1rem;

      .pa-cancel{
        box-sizing:border-box;

        margin-top:0;
        border-top:1px solid #C6AA89;
        text-align: center;

        button{
          margin-top:.4rem;
          font-size:1.2rem;
          font-weight: normal;
        }
      }
    }
  }

  .pa-loading-set{
    .pa-loading-field, .pa-loading-overlay{
      z-index: 1;
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:500px;
      text-align: center;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;align-items: center;
    }

    .pa-loading-overlay{
      z-index:0;
      background:linear-gradient(0deg, rgba($body-background-darker, .7), rgba($body-background-darker, .5));
      backdrop-filter: blur(3px) opacity(.9);
    }
  }
}
</style>